import { SELECTED } from "../Fetch/constants";
import {
  ACTIVE_TAB_DOC_VIEW,
  ACTIVE_TAB_RECO,
  ACTIVE_TAB_VIEW_RECO,
  AVAILED_FILTER,
  BASE_DATA_FILTER,
  DATE_RANGE,
  DATE_RANGE_FILTER,
  DOC_DATE_TABLE_DATA,
  DOC_VIEW_TABLE_DATA,
  INUM_FILTER,
  ISSUE_WISE_TABLE_DATA,
  LOADER_STATUS,
  MONTH_3B_FILTER,
  MONTH_FILTER,
  PAGE_NO_RECO_HISTORY,
  R_GSTIN_TAXPAYER_FILTER,
  RECO_HISTORY_TABLE_DATA,
  S_GSTIN_TAXPAYER_FILTER,
  SEARCH_STR_RECO,
  SELECTED_MATCHED,
  SELECTED_MISMATCH,
  SELECTED_PROBABLE,
  SELECTED_NOTINPR,
  SELECTED_NOTINGSTN,
  SELECTED_REJECTED,
  SUPPLIER_WISE_TABLE_DATA,
  TOTAL_PAGES_RECO_HISTORY,
  VIEW_RECO_TABLE_DATA,
  SELECTION,
  RECO_SELECTION,
  SELECTED_YEAR,
  TAXABLE_VALUE,
  TAX_RATE,
  TOTAL_PAGES_REJECTED,
  TOTAL_PAGES_NOT_IN_GSTN,
  TOTAL_PAGES_NOT_IN_PR,
  TOTAL_PAGES_MISMATCH,
  TOTAL_PAGES_PROBABLE,
  TOTAL_PAGES_MATCHED,
  PAGE_NO_REJECTED,
  PAGE_NO_NOT_IN_GSTN,
  PAGE_NO_NOT_IN_PR,
  PAGE_NO_MISMATCH,
  PAGE_NO_MATCHED,
  PAGE_NO_PROBABLE,
  SELECTED_ROW_PROBABLE,
  SELECTED_ROW_MISMATCH,
  DOWNLOAD_REPORT_TABLE_DATA,
  UPLOAD_REPORT_TABLE_DATA,
  TOTAL_PAGES_UPLOAD_REPORT,
  PAGE_NO_UPLOAD_REPORT,
  VENDOR_LIST,
  SELECTED_ROW_NOT_IN_GSTN,
  SELECTED_ROW_NOT_IN_PR,
  SELECTED_ROW_MATCHED,
  SELECTED_ROW_REJECTED,
} from "./constants";

// The initial state of the App
export const initialState = {
  activeTabReco: "1",
  activeTabViewReco: "1",
  activeTabDocView: "1",
  loaderStatus: false,
  recoHistoryTableData: [],
  viewRecoTableData: [],
  issueWiseTableData: [],
  docViewTableData: [],
  supplierWiseTableData: [],
  downloadReportTableData: [],
  uploadReportTableData: [],
  docDateTableData: [],
  searchStr: "",
  selectedMatched: [],
  selectedProbable: [],
  selectedMismatch: [],
  selectedNotInPR: [],
  selectedNotInGstn: [],
  selectedRejected: [],
  rgstinTaxpayerFilter: [],
  sgstinTaxpayerFilter: [],
  inumFilter: [],
  monthFilter: [],
  month3bFilter: [],
  baseDataFilter: [],
  availedFilter: [],
  vendorList: [],
  dateRange: [
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ],
  dateRangeFilter: [
    {
      startDate: null,
      endDate: new Date(),
      key: "selection",
    },
  ],
  totalPagesRecoHistory: 0,
  pageNoRecoHistory: 1,
  selection: "",
  recoSelection: "",
  selectedYear: "",

  totalPageMatched: 1,
  totalPageMismatch: 1,
  totalPageProbable: 1,
  totalPageNotInGstn: 1,
  totalPageNotInPr: 1,
  totalPageRejected: 1,

  pageNoMatched: 1,
  pageNoMismatch: 1,
  pageNoProbable: 1,
  pageNoNotInGstn: 1,
  pageNoNotInPr: 1,
  pageNoRejected: 1,

  selectedRowProbable: [],
  selectedRowMismatch: [],
  selectedRowNotInGstn: [],
  selectedRowNotInPR: [],
  selectedRowMatched: [],
  selectedRowRejected: [],

  pageNoUploadReport: 1,
  totalPagesUploadReport: 1,
};

/* eslint-disable default-case, no-param-reassign */
const gstr2a2bNewRecoReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case ACTIVE_TAB_RECO:
      return {
        ...state,
        activeTabReco: action.payload,
      };
    case ACTIVE_TAB_VIEW_RECO:
      return {
        ...state,
        activeTabViewReco: action.payload,
      };
    case ACTIVE_TAB_DOC_VIEW:
      return {
        ...state,
        activeTabDocView: action.payload,
      };
    case RECO_HISTORY_TABLE_DATA:
      return {
        ...state,
        recoHistoryTableData: action.payload,
      };
    case VIEW_RECO_TABLE_DATA:
      return {
        ...state,
        viewRecoTableData: action.payload,
      };
    case ISSUE_WISE_TABLE_DATA:
      return {
        ...state,
        issueWiseTableData: action.payload,
      };
    case DOC_VIEW_TABLE_DATA:
      return {
        ...state,
        docViewTableData: action.payload,
      };
    case SUPPLIER_WISE_TABLE_DATA:
      return {
        ...state,
        supplierWiseTableData: action.payload,
      };
    case DOWNLOAD_REPORT_TABLE_DATA:
      return {
        ...state,
        downloadReportTableData: action.payload,
      };
    case UPLOAD_REPORT_TABLE_DATA:
      return {
        ...state,
        uploadReportTableData: action.payload,
      };
    case DOC_DATE_TABLE_DATA:
      return {
        ...state,
        docDateTableData: action.payload,
      };
    case SEARCH_STR_RECO:
      return {
        ...state,
        searchStr: action.payload,
      };
    case SELECTED_MATCHED:
      return {
        ...state,
        selectedMatched: action.payload,
      };
    case SELECTED_PROBABLE:
      return {
        ...state,
        selectedProbable: action.payload,
      };
    case SELECTED_MISMATCH:
      return {
        ...state,
        selectedMismatch: action.payload,
      };

    case SELECTED_NOTINPR:
      return {
        ...state,
        selectedNotInPR: action.payload,
      };
    case SELECTED_NOTINGSTN:
      return {
        ...state,
        selectedNotInGstn: action.payload,
      };

    case SELECTED_REJECTED:
      return {
        ...state,
        selectedRejected: action.payload,
      };

    case R_GSTIN_TAXPAYER_FILTER:
      return {
        ...state,
        rgstinTaxpayerFilter: action.payload,
      };
    case S_GSTIN_TAXPAYER_FILTER:
      return {
        ...state,
        sgstinTaxpayerFilter: action.payload,
      };
    case INUM_FILTER:
      return {
        ...state,
        inumFilter: action.payload,
      };
    case MONTH_FILTER:
      return {
        ...state,
        monthFilter: action.payload,
      };
    case MONTH_3B_FILTER:
      return {
        ...state,
        month3bFilter: action.payload,
      };
    case BASE_DATA_FILTER:
      return {
        ...state,
        baseDataFilter: action.payload,
      };
    case AVAILED_FILTER:
      return {
        ...state,
        availedFilter: action.payload,
      };
    case DATE_RANGE:
      return {
        ...state,
        dateRange: action.payload,
      };
    case DATE_RANGE_FILTER:
      return {
        ...state,
        dateRangeFilter: action.payload,
      };
    case TOTAL_PAGES_RECO_HISTORY:
      return {
        ...state,
        totalPagesRecoHistory: action.payload,
      };
    case PAGE_NO_RECO_HISTORY:
      return {
        ...state,
        pageNoRecoHistory: action.payload,
      };
    case SELECTION:
      return {
        ...state,
        selection: action.payload,
      };
    case RECO_SELECTION:
      return {
        ...state,
        recoSelection: action.payload,
      };
    case SELECTED_YEAR:
      return {
        ...state,
        selectedYear: action.payload,
      };
    case TOTAL_PAGES_MATCHED:
      return {
        ...state,
        totalPageMatched: action.totalPageMatched,
      };
    case TOTAL_PAGES_PROBABLE:
      return {
        ...state,
        totalPageProbable: action.totalPageProbable,
      };
    case TOTAL_PAGES_MISMATCH:
      return {
        ...state,
        totalPageMismatch: action.totalPageMismatch,
      };
    case TOTAL_PAGES_NOT_IN_PR:
      return {
        ...state,
        totalPageNotInPr: action.totalPageNotInPr,
      };
    case TOTAL_PAGES_NOT_IN_GSTN:
      return {
        ...state,
        totalPageNotInGstn: action.totalPageNotInGstn,
      };
    case TOTAL_PAGES_REJECTED:
      return {
        ...state,
        totalPageRejected: action.totalPageRejected,
      };
    case PAGE_NO_MATCHED:
      return {
        ...state,
        pageNoMatched: action.pageNoMatched,
      };
    case PAGE_NO_PROBABLE:
      return {
        ...state,
        pageNoProbable: action.pageNoProbable,
      };
    case PAGE_NO_MISMATCH:
      return {
        ...state,
        pageNoMismatch: action.pageNoMismatch,
      };
    case PAGE_NO_NOT_IN_PR:
      return {
        ...state,
        pageNoNotInPr: action.pageNoNotInPr,
      };
    case PAGE_NO_NOT_IN_GSTN:
      return {
        ...state,
        pageNoNotInGstn: action.pageNoNotInGstn,
      };
    case PAGE_NO_REJECTED:
      return {
        ...state,
        pageNoRejected: action.pageNoRejected,
      };

    case SELECTED_ROW_PROBABLE:
      return {
        ...state,
        selectedRowProbable: action.selectedRowProbable,
      };
    case SELECTED_ROW_MISMATCH:
      return {
        ...state,
        selectedRowMismatch: action.selectedRowMismatch,
      };

    case SELECTED_ROW_NOT_IN_GSTN:
      return {
        ...state,
        selectedRowNotInGstn: action.selectedRowNotInGstn,
      };

    case SELECTED_ROW_NOT_IN_PR:
      return {
        ...state,
        selectedRowNotInPR: action.selectedRowNotInPR,
      };
    case SELECTED_ROW_MATCHED:
      return {
        ...state,
        selectedRowMatched: action.selectedRowMatched,
      };

    case SELECTED_ROW_REJECTED:
      return {
        ...state,
        selectedRowRejected: action.selectedRowRejected,
      };

    case PAGE_NO_UPLOAD_REPORT:
      return {
        ...state,
        pageNoUploadReport: action.pageNoUploadReport,
      };
    case TOTAL_PAGES_UPLOAD_REPORT:
      return {
        ...state,
        totalPagesUploadReport: action.totalPagesUploadReport,
      };
    case VENDOR_LIST:
      return {
        ...state,
        vendorList: action.vendorList,
      };
    default:
      return state;
  }
};

export default gstr2a2bNewRecoReducer;
